// Generated list of every public page route (for /admin/pages CSV export).
export const allPages: string[] = [
  "https://restorehair.com",
  "https://restorehair.com/about-us/",
  "https://restorehair.com/auth/",
  "https://restorehair.com/careers/",
  "https://restorehair.com/considering-hair-restoration/",
  "https://restorehair.com/consumer-rights-request/",
  "https://restorehair.com/contact-us/",
  "https://restorehair.com/contact-us/confirmation-2s/",
  "https://restorehair.com/cookies/",
  "https://restorehair.com/doctors/",
  "https://restorehair.com/doctors/dr-adam-cloninger/",
  "https://restorehair.com/doctors/dr-anish-patel/",
  "https://restorehair.com/doctors/dr-broc-pratt/",
  "https://restorehair.com/doctors/dr-fahad-juboori/",
  "https://restorehair.com/doctors/dr-james-harris/",
  "https://restorehair.com/doctors/dr-shadia-saleh/",
  "https://restorehair.com/doctors/dr-shelly-lovitt/",
  "https://restorehair.com/hair-implants/",
  "https://restorehair.com/hair-loss/",
  "https://restorehair.com/hair-replacement/",
  "https://restorehair.com/hair-sciences-center/",
  "https://restorehair.com/hair-transplant-faqs/",
  "https://restorehair.com/locations/",
  "https://restorehair.com/locations/arizona/",
  "https://restorehair.com/locations/arizona/phoenix/",
  "https://restorehair.com/locations/arizona/scottsdale/",
  "https://restorehair.com/locations/california/",
  "https://restorehair.com/locations/california/beverly-hills/",
  "https://restorehair.com/locations/california/newport-beach/",
  "https://restorehair.com/locations/california/san-diego/",
  "https://restorehair.com/locations/california/san-francisco/",
  "https://restorehair.com/locations/colorado/",
  "https://restorehair.com/locations/colorado/boulder/",
  "https://restorehair.com/locations/colorado/colorado-springs/",
  "https://restorehair.com/locations/district-of-columbia/",
  "https://restorehair.com/locations/florida/",
  "https://restorehair.com/locations/florida/boca-raton/",
  "https://restorehair.com/locations/florida/jacksonville/",
  "https://restorehair.com/locations/florida/miami/",
  "https://restorehair.com/locations/florida/tampa/",
  "https://restorehair.com/locations/georgia/",
  "https://restorehair.com/locations/georgia/atlanta/",
  "https://restorehair.com/locations/illinois/",
  "https://restorehair.com/locations/indiana/",
  "https://restorehair.com/locations/indiana/indianapolis/",
  "https://restorehair.com/locations/louisiana/",
  "https://restorehair.com/locations/louisiana/new-orleans/",
  "https://restorehair.com/locations/maryland/",
  "https://restorehair.com/locations/maryland/baltimore/",
  "https://restorehair.com/locations/massachusetts/",
  "https://restorehair.com/locations/massachusetts/boston/",
  "https://restorehair.com/locations/michigan/",
  "https://restorehair.com/locations/michigan/novi/",
  "https://restorehair.com/locations/minnesota/",
  "https://restorehair.com/locations/minnesota/edina/",
  "https://restorehair.com/locations/missouri/",
  "https://restorehair.com/locations/missouri/kansas-city/",
  "https://restorehair.com/locations/missouri/st-louis/",
  "https://restorehair.com/locations/nevada/",
  "https://restorehair.com/locations/nevada/las-vegas/",
  "https://restorehair.com/locations/new-jersey/",
  "https://restorehair.com/locations/new-jersey/neptune/",
  "https://restorehair.com/locations/new-jersey/newark/",
  "https://restorehair.com/locations/new-jersey/paramus/",
  "https://restorehair.com/locations/new-york/",
  "https://restorehair.com/locations/new-york/brooklyn-heights/",
  "https://restorehair.com/locations/new-york/nassau-county/",
  "https://restorehair.com/locations/new-york/queens/",
  "https://restorehair.com/locations/new-york/white-plains/",
  "https://restorehair.com/locations/nyc/",
  "https://restorehair.com/locations/north-carolina/",
  "https://restorehair.com/locations/north-carolina/raleigh/",
  "https://restorehair.com/locations/ohio/",
  "https://restorehair.com/locations/ohio/cincinnati/",
  "https://restorehair.com/locations/ohio/columbus/",
  "https://restorehair.com/locations/ohio/independence/",
  "https://restorehair.com/locations/oklahoma/",
  "https://restorehair.com/locations/oklahoma/oklahoma-city/",
  "https://restorehair.com/locations/oregon/",
  "https://restorehair.com/locations/oregon/portland/",
  "https://restorehair.com/locations/pennsylvania/",
  "https://restorehair.com/locations/pennsylvania/philadelphia/",
  "https://restorehair.com/locations/pennsylvania/pittsburgh/",
  "https://restorehair.com/locations/restore-denver/",
  "https://restorehair.com/locations/restore-midwest/",
  "https://restorehair.com/locations/restore-south/",
  "https://restorehair.com/locations/restore-west/",
  "https://restorehair.com/locations/tennessee/",
  "https://restorehair.com/locations/tennessee/nashville/",
  "https://restorehair.com/locations/texas/",
  "https://restorehair.com/locations/texas/allen/",
  "https://restorehair.com/locations/texas/austin/",
  "https://restorehair.com/locations/texas/dallas-highland-park/",
  "https://restorehair.com/locations/texas/fort-worth/",
  "https://restorehair.com/locations/texas/houston/",
  "https://restorehair.com/locations/texas/san-antonio/",
  "https://restorehair.com/locations/texas/south-lake/",
  "https://restorehair.com/locations/utah/",
  "https://restorehair.com/locations/utah/salt-lake-city/",
  "https://restorehair.com/locations/virginia/",
  "https://restorehair.com/locations/virginia/virginia-beach/",
  "https://restorehair.com/locations/wisconsin/",
  "https://restorehair.com/locations/wisconsin/milwaukee/",
  "https://restorehair.com/media-outlet/",
  "https://restorehair.com/national-west/",
  "https://restorehair.com/no-shave-fue-hair-transplant/",
  "https://restorehair.com/non-surgical/",
  "https://restorehair.com/pricing/",
  "https://restorehair.com/privacy-policy/",
  "https://restorehair.com/procedure/",
  "https://restorehair.com/quick-quote-norwood-page-1/",
  "https://restorehair.com/quick-quote-page-2/",
  "https://restorehair.com/quick-quote-part-1/",
  "https://restorehair.com/locations/restore-charlotte/",
  "https://restorehair.com/locations/restore-chicago/",
  "https://restorehair.com/locations/restore-dallas/",
  "https://restorehair.com/locations/restore-northeast/",
  "https://restorehair.com/restore-pledge/",
  "https://restorehair.com/results/",
  "https://restorehair.com/results/brian-urlacher/",
  "https://restorehair.com/results/bryan-bickell/",
  "https://restorehair.com/results/danny-kanell/",
  "https://restorehair.com/results/deion-sanders/",
  "https://restorehair.com/results/heath-evans/",
  "https://restorehair.com/results/robert-l/",
  "https://restorehair.com/results/ian-happ/",
  "https://restorehair.com/results/jim-cornelison/",
  "https://restorehair.com/results/kevin-streelman/",
  "https://restorehair.com/results/kevin-vandam/",
  "https://restorehair.com/results/matt-forte/",
  "https://restorehair.com/results/mike-bibby/",
  "https://restorehair.com/results/pat-hoberg/",
  "https://restorehair.com/results/ryne-sandberg/",
  "https://restorehair.com/results/zach-johnson/",
  "https://restorehair.com/reviews/",
  "https://restorehair.com/schedule-a-consult/",
  "https://restorehair.com/schedule-a-consult/boulder/",
  "https://restorehair.com/schedule-a-consult/charlotte/",
  "https://restorehair.com/schedule-a-consult/denver/",
  "https://restorehair.com/schedule-a-consult/fulton-market/",
  "https://restorehair.com/schedule-a-consult/greenwood-village/",
  "https://restorehair.com/schedule-a-consult/lake-forest/",
  "https://restorehair.com/schedule-a-consult/lincoln-park/",
  "https://restorehair.com/schedule-a-consult/manhattan/",
  "https://restorehair.com/schedule-a-consult/oak-brook/",
  "https://restorehair.com/schedule-a-consult/plano/",
  "https://restorehair.com/schedule-a-consult/schaumburg/",
  "https://restorehair.com/schedule-a-consult/virtual/",
  "https://restorehair.com/see-how-id-look-with-a-hair-transplant/",
  "https://restorehair.com/tc-mobilesms/",
  "https://restorehair.com/terms-of-use/",
  "https://restorehair.com/test/",
  "https://restorehair.com/thanks/",
  "https://restorehair.com/values-mission/",
  "https://restorehair.com/what-to-expect-at-your-hair-restoration-consultation/",
  "https://restorehair.com/why-restore/"
];
